import { JoveLanguageEnum } from '../languages/common';
export var internationalizationNextLocaleMap = {
  US: {
    languageKey: JoveLanguageEnum.EN,
    countryKey: 'us',
    countryCode: 'US'
  },
  GB: {
    languageKey: JoveLanguageEnum.EN,
    countryKey: 'uk',
    countryCode: 'GB'
  },
  IM: {
    languageKey: JoveLanguageEnum.EN,
    countryKey: 'im',
    countryCode: 'IM'
  },
  GI: {
    languageKey: JoveLanguageEnum.EN,
    countryKey: 'gi',
    countryCode: 'GI'
  },
  GG: {
    languageKey: JoveLanguageEnum.EN,
    countryKey: 'gg',
    countryCode: 'GG'
  },
  JE: {
    languageKey: JoveLanguageEnum.EN,
    countryKey: 'je',
    countryCode: 'JE'
  },
  AT: {
    languageKey: JoveLanguageEnum.AT,
    countryKey: 'at',
    countryCode: 'AT'
  },
  BE: {
    languageKey: JoveLanguageEnum.NL_BE,
    countryKey: 'be',
    countryCode: 'BE'
  },
  BG: {
    languageKey: JoveLanguageEnum.BG,
    countryKey: 'bg',
    countryCode: 'BG'
  },
  HR: {
    languageKey: JoveLanguageEnum.HR,
    countryKey: 'hr',
    countryCode: 'HR'
  },
  CY: {
    languageKey: JoveLanguageEnum.CY,
    countryKey: 'cy',
    countryCode: 'CY'
  },
  CZ: {
    languageKey: JoveLanguageEnum.CZ,
    countryKey: 'cz',
    countryCode: 'CZ'
  },
  DK: {
    languageKey: JoveLanguageEnum.DK,
    countryKey: 'dk',
    countryCode: 'DK'
  },
  EE: {
    languageKey: JoveLanguageEnum.EE,
    countryKey: 'ee',
    countryCode: 'EE'
  },
  FI: {
    languageKey: JoveLanguageEnum.FI,
    countryKey: 'fi',
    countryCode: 'FI'
  },
  FR: {
    languageKey: JoveLanguageEnum.FR,
    countryKey: 'fr',
    countryCode: 'FR'
  },
  DE: {
    languageKey: JoveLanguageEnum.DE,
    countryKey: 'de',
    countryCode: 'DE'
  },
  GR: {
    languageKey: JoveLanguageEnum.GR,
    countryKey: 'gr',
    countryCode: 'GR'
  },
  HU: {
    languageKey: JoveLanguageEnum.HU,
    countryKey: 'hu',
    countryCode: 'HU'
  },
  IS: {
    languageKey: JoveLanguageEnum.EN,
    countryKey: 'is',
    countryCode: 'IS'
  },
  IE: {
    languageKey: JoveLanguageEnum.EN,
    countryKey: 'ie',
    countryCode: 'IE'
  },
  IT: {
    languageKey: JoveLanguageEnum.IT,
    countryKey: 'it',
    countryCode: 'IT'
  },
  LV: {
    languageKey: JoveLanguageEnum.LV,
    countryKey: 'lv',
    countryCode: 'LV'
  },
  LI: {
    languageKey: JoveLanguageEnum.DE,
    countryKey: 'li',
    countryCode: 'LI'
  },
  LT: {
    languageKey: JoveLanguageEnum.LT,
    countryKey: 'lt',
    countryCode: 'LT'
  },
  LU: {
    languageKey: JoveLanguageEnum.LU,
    countryKey: 'lu',
    countryCode: 'LU'
  },
  MT: {
    languageKey: JoveLanguageEnum.MT,
    countryKey: 'mt',
    countryCode: 'MT'
  },
  NL: {
    languageKey: JoveLanguageEnum.NL_NL,
    countryKey: 'nl',
    countryCode: 'NL'
  },
  NO: {
    languageKey: JoveLanguageEnum.NO,
    countryKey: 'no',
    countryCode: 'NO'
  },
  PL: {
    languageKey: JoveLanguageEnum.PL,
    countryKey: 'pl',
    countryCode: 'PL'
  },
  PT: {
    languageKey: JoveLanguageEnum.PT,
    countryKey: 'pt',
    countryCode: 'PT'
  },
  RO: {
    languageKey: JoveLanguageEnum.RO,
    countryKey: 'ro',
    countryCode: 'RO'
  },
  SK: {
    languageKey: JoveLanguageEnum.SK,
    countryKey: 'sk',
    countryCode: 'SK'
  },
  SI: {
    languageKey: JoveLanguageEnum.SL,
    countryKey: 'si',
    countryCode: 'SI'
  },
  ES: {
    languageKey: JoveLanguageEnum.ES_ES,
    countryKey: 'es',
    countryCode: 'ES'
  },
  SE: {
    languageKey: JoveLanguageEnum.SE,
    countryKey: 'se',
    countryCode: 'SE'
  }
};
export var getInternationalizationCountryCodeByUrlCountryValue = function getInternationalizationCountryCodeByUrlCountryValue(value) {
  var valueList = Object.values(internationalizationNextLocaleMap);
  var findItem = valueList.find(function (item) {
    return item.countryKey === value;
  });
  return (findItem === null || findItem === void 0 ? void 0 : findItem.countryCode) || 'GB';
};
export var getUrlCountryKeyByCountryCode = function getUrlCountryKeyByCountryCode(countryCode) {
  if (!countryCode) return 'uk';
  var entry = internationalizationNextLocaleMap[countryCode.toUpperCase()];
  return (entry === null || entry === void 0 ? void 0 : entry.countryKey) || 'uk';
};
export var getMainLanguageByCountryCode = function getMainLanguageByCountryCode(countryCode) {
  if (!countryCode) return JoveLanguageEnum.EN;
  var entry = internationalizationNextLocaleMap[countryCode.toUpperCase()];
  return (entry === null || entry === void 0 ? void 0 : entry.languageKey) || JoveLanguageEnum.EN;
};